import { Component } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  template: ''
})
export abstract class AbstractComponent {
  protected destroyed$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
